export default function createState() {
  return {
    items: [],
    pagination: {
      current: 1,
      perPage: 10,
      total: 0,
      lastPage: 1,
    },
    counts: {
      todos: 0,
      ativos: 0,
      inativos: 0,
    },
    countsSearch: null,
    filters: {
      search: '',
      status: 'todos',
      sort: null,
      personIds: [],
    },
    loading: false,
    error: null,
  };
}
